// extracted by mini-css-extract-plugin
module.exports = {"main-component":"blockerResolved_main-component__UQ5jq"};